/* eslint-disable */
import { TrackJS } from 'trackjs';
import MarketingClient from 'marketing-app-js-vendor';

import config from '@fr/config/appConfig';

const clientUuid = window.appConfig?.clientUuid;
const includedPath =  window.location.pathname !== '/tinkoff/frame-mobile-new';

if (!clientUuid && includedPath) {
    TrackJS.track('No clientUuid provided!!');
}

let marketingClient = null;

if (includedPath) {
    try {
        marketingClient = new MarketingClient({
            config: config.marketingClientConfig,
            clientUuid,
        });
    } catch (err) {
        TrackJS.track(err);
    }
}


export default marketingClient;
